const items = [
  {
    title: 'ABOUT THIS POLICY',
    summary: (
      <>
        <p>
          We’ll only ever use cookies and other similar technologies for the
          purposes set out in this policy.
        </p>
        <p>
          Along with our Terms of Service and Privacy Policy, this policy
          provides you with information about the cookies and other similar
          technologies that are used by us. We’ll review this policy from time
          to time to make sure it’s up-to-date. If we make changes, we’ll post
          the latest version here. When we make significant changes, we’ll let
          you know when you next access our services, or by other
          communications.
        </p>
      </>
    ),
    details: null
  },
  {
    title: "WHAT'S A COOKIE?",
    summary: (
      <>
        <p>
          A "cookie" is a piece of information that is stored on your computer's
          hard drive if you agree to this and which records how you move your
          way around a website so that, when you revisit that website, it can
          present tailored options based on the information stored about your
          last visit. Cookies can also be used to analyse traffic and for
          advertising and marketing purposes.
        </p>
        <p>
          Cookies are used by nearly all websites and do not harm your system.
          We are required to obtain your consent for all non-essential cookies
          used on our website. You can block cookies (including essential
          cookies) at any time by activating the setting on your browser that
          allows you to refuse the setting of all or some cookies. However, if
          you use your browser settings to block essential cookies you may not
          be able to access all or parts of our site.
        </p>
      </>
    ),
    details: null
  },
  {
    title: 'HOW DO WE USE COOKIES?',
    summary: (
      <>
        <p>
          When you access Joblio via our website or app, we use cookies and
          similar technologies. This enables us to understand how you use the
          site and track any patterns with regards how you are using our
          website. This helps us to develop and improve our website as well as
          products and / or services in response to what you might need or want.
          Cookies that we use fall under the three categories listed below.
        </p>
      </>
    ),
    details: (
      <>
        <h4>1. The Essential Cookies</h4>
        <p>
          Your data is collected or accessed using cookies and similar
          technologies that are essential to the proper functioning of our
          services. Like other websites and apps, you can't opt out of these
          cookies and similar technologies because without them, Joblio wouldn't
          work. We restrict these cookies and similar technologies to only those
          that are strictly necessary for us to deliver the products and
          services you have requested.
        </p>
        <p>
          For example, we use essential cookies and similar technologies to:
        </p>
        <ul>
          <li>
            remember information that is essential to determining how your
            search results are displayed, such as your language;
          </li>
          <li>
            save the your filters during the interaction with the website;
          </li>
          <li>provide login functionality and customer support services</li>
          <li>
            gather important information about how Joblio is used which
            influence vital product decisions, updates and changes and the
            features we make available;
          </li>
          <li>
            ensure our services are secure from automated agents, bots and
            fraudulent activity.
          </li>
        </ul>

        <h4>2. Functionality Cookies</h4>
        <p>
          Your data is stored or accessed via cookies and similar technologies
          that are used to optimise and personalise your experience of the
          Joblio. Without them, Joblio would feel a lot less easy to use and you
          would not benefit from the best possible experience.
        </p>
        <p>
          These cookies and similar technologies help improve your experience by
          allowing us to:
        </p>
        <ul>
          <li>
            analyse and measure product improvements and guide our product
            development teams based on your activities; and
          </li>
          <li>
            gather feedback about how you use Joblio and how our services
            perform on your device.
          </li>
        </ul>
        <p>
          These cookies and similar technologies help us to make decisions about
          how best to develop or deliver our product to meet your needs.
        </p>
        <p>
          You can opt out of the use of these cookies and similar technologies
          on your device by following the instructions in the How can I withdraw
          my consent to the use of cookies and similar technologies? section of
          this policy.
        </p>

        <h4>3. Personalise your vacancies cookies</h4>
        <p>
          Your data may be collected and accessed using cookies and similar
          technologies to personalise the vacancies you see while using our
          services and elsewhere on the web if you agree to. These cookies also
          allow us to count visits and traffic sources to measure and improve
          the performance of our web application.
        </p>
        <p>
          For example, we use this type of cookies and similar technologies to:
        </p>
        <ul>
          <li>
            define the source from which the end-user comes to the website.
          </li>
          <li>select the proper set of vacancies for this user</li>
        </ul>

        <h4>4. Required Analytics Cookies</h4>
        <p>
          Your data helps to capture the analytics data to improve the UX of our
          web application.
        </p>
        <p>
          For example, we use this type of cookies and similar technologies for
          Google Analytics interactions.
        </p>

        <h4>5. First and third party cookies</h4>
        <p>
          First party cookies are cookies set by our website or app. Third party
          cookies are cookies on our website that are set by a website other
          than our website, such as where we have adverts on our website or use
          Facebook pixels so that we can show you relevant content from us when
          you are on Facebook.
        </p>
      </>
    )
  },
  {
    title:
      'HOW CAN I WITHDRAW MY CONSENT TO THE USE OF COOKIES AND SIMILAR TECHNOLOGIES?',
    summary: (
      <>
        <p>
          You can alter your cookie preferences at any time. When you access our
          services for the first time on your device, we ask you to agree to us
          using cookies and similar technologies in line with this policy. If
          you don't agree to our use of these technologies, or you change your
          mind at a later date, you can withdraw your consent using the methods
          set out in this policy or alternatively, stop using our services.
          Please refresh your page to ensure that the new settings have taken
          effect.
        </p>
      </>
    ),
    details: (
      <>
        <p>
          When you access our services for the first time on your device, we ask
          you to agree to us using cookies and similar technologies in line with
          this policy. If you don't agree to our use of these technologies, or
          you change your mind at a later date, you can withdraw your consent
          using the methods set out in this policy or alternatively, stop using
          our services.
        </p>

        <h4>Browser or device settings</h4>
        <p>
          Another way to opt out of cookies and similar technologies is via the
          settings of the browser or device you are using to access our
          services. Internet browsers such as Chrome, Safari, Firefox, Opera and
          Edge have settings that allow you to control the way your information
          is collected and shared. Typically, these browsers allow you to view
          all the cookies they are storing on your device, delete your cache of
          cookies, and adjust your preferences for future collection. Guides on
          how to access and use such functionality are available at{' '}
          <a
            href="https://www.aboutcookies.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.aboutcookies.org
          </a>
          .
        </p>
        <p>
          The downside of using browser or device settings to withdraw your
          consent is that it will have the effect of disabling many of the
          cookies and similar technologies that are essential to enabling our
          services to function – the impact of this is that some or all of the
          features and functionality we offer may stop working. Because of this,
          we would recommend taking a more targeted approach to withdrawing your
          consent.
        </p>
        <p>
          You can also find helpful information about how to manage and limit
          your exposure to online interest-based advertising more generally
          across the web at{' '}
          <a
            href="http://optout.aboutads.info"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://optout.aboutads.info
          </a>
          ,{' '}
          <a
            href="http://optout.networkadvertising.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://optout.networkadvertising.org
          </a>{' '}
          and{' '}
          <a
            href="http://youronlinechoices.eu"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://youronlinechoices.eu
          </a>
          . You can use these services to opt-out of the majority of
          interest-based advertising used by us as well as other websites.
        </p>
      </>
    )
  },
  {
    title: 'HOW CAN YOU CONTACT US',
    summary: (
      <>
        <p>
          If you have any questions about the cookies that we use, feel free to
          contact our Data Protection Officer by post at Joblio, 21500 Biscayne
          Blvd., Suite #400, Aventure, FL., USA. 33180, or electronically via{' '}
          <a href="mailto:support@joblio.co">support@joblio.co</a>.
        </p>
      </>
    ),
    details: (
      <>
        <p>
          Some of the cookies we commonly use are listed below. This list is not
          exhaustive, but it is intended to illustrate the primary purposes for
          which we typically set cookies. If you visit one of our websites, the
          site will set some or all of the following cookies:
        </p>

        <table>
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Purpose</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>MUID, MC1, and MSFPC</td>
              <td>
                This cookies enable us to: Identifies unique web browsers
                visiting Joblio sites. These cookies are used for advertising,
                site analytics, and other operational purposes.
              </td>
            </tr>
            <tr>
              <td>CC</td>
              <td>
                These cookies are used to collect information about a country
                code as determined from your IP address.
              </td>
            </tr>
            <tr>
              <td>MC0</td>
              <td>
                This cookie is set to detect whether cookies are enabled in the
                browser.
              </td>
            </tr>
            <tr>
              <td>MS0</td>
              <td>This cookie is essential to identify a specific session</td>
            </tr>
            <tr>
              <td>NAP</td>
              <td>
                This cookie contains an encrypted version of your country,
                postal code, age, gender, language and occupation, if known,
                based on your Microsoft account profile.
              </td>
            </tr>
          </tbody>
        </table>
      </>
    )
  }
];

export default items;
